import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { message } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { eramanBEApi, eramanCMSApi, post } from "~/Services";
import { eramanApiURL } from "~/Utils";
import { fields } from "../FormsSubmissions/constants";
import { useEpcApplicationDocumentDetails } from "./EpcApplication.hook";
import EPCCardDisplay from "./EpcCardDisplay";

export const AddEditEpcApplications = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [epcCardBarcode, setEpcCardBarcode] = useState<any>("");
  const [epcCard, setEpcCard] = useState("");
  const [cardExpiryDate, setCardExpiryDate] = useState("");
  const [cardEPCId, setCaredEPCId] = useState("");
  const {
    data: editEpcApplications,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditEpcApplications,
  } = useEpcApplicationDocumentDetails(query.get("editId") || "");

  const {
    data: editEpcApplicationsById,
    isLoading: isLoadingEpcApplications,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditEpcApplications();
    }
  }, [query.get("editId"), query.get("id")]);

  useEffect(() => {
    console.log("editEpcApplicationsssssssssss", editEpcApplications);

    const fetchData = async () => {
      try {
        const emailAddress = editEpcApplications?.emailAddress || editEpcApplicationsById?.payload?.emailAddress;

        if (!emailAddress) return;

        const response = await eramanBEApi.get(`/user/epcCardBarCode?emailAddress=${emailAddress}`);
        const response2 = await eramanCMSApi.get(`/api/epc-detailsandcard`);
        let cardImage: any = "";
        if (editEpcApplications?.epcType === "PRIORITY" || editEpcApplicationsById?.payload?.epcType === "PRIORITY") {
          cardImage = response2.data?.[0].field_epc_card3;
        } else if (
          editEpcApplications?.epcType === "CLASSIC" ||
          editEpcApplicationsById?.payload?.epcType === "CLASSIC"
        ) {
          cardImage = response2.data?.[0].field_epc_card1;
        } else if (
          editEpcApplications?.epcType === "PREFERRED" ||
          editEpcApplicationsById?.payload?.epcType === "PREFERRED"
        ) {
          cardImage = response2.data?.[0].field_epc_card2;
        }
        console.log("responseeeeeeee", response.data, cardImage);
        setEpcCardBarcode(`${eramanApiURL}/user/epcCardBarCode?emailAddress=${emailAddress}`);
        setEpcCard(cardImage);
        setCardExpiryDate(editEpcApplications?.epcExpiry || editEpcApplicationsById?.payload?.epcExpiry);
        setCaredEPCId(editEpcApplications?.epcId || editEpcApplicationsById?.payload?.epcId);
      } catch (error) {
        console.error("Error fetching EPC details:", error);
      }
    };

    fetchData();
  }, [editEpcApplications, editEpcApplicationsById]);

  console.log("epccarddetialsssss", epcCard, epcCardBarcode, cardExpiryDate, cardEPCId);

  const epcApplicationsFormConfig: FormConfig = {
    initialValues: {
      epcId: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.epcId)
        : decodeHTML(editEpcApplications?.epcId),
      epsId: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.epsId)
        : decodeHTML(editEpcApplications?.epsId),
      epcType: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.epcType)
        : decodeHTML(editEpcApplications?.epcType),
      epcStatus: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.epcStatus)
        : decodeHTML(editEpcApplications?.epcStatus),
      epcExpiry: editEpcApplicationsById?.payload?.epcExpiry
        ? moment(decodeHTML(editEpcApplicationsById?.payload?.epcExpiry), "YYYY/MM/DD").isValid()
          ? moment(decodeHTML(editEpcApplicationsById?.payload?.epcExpiry), "YYYY/MM/DD").format("YYYY-MM-DD")
          : undefined
        : editEpcApplications?.epcExpiry
          ? moment(decodeHTML(editEpcApplications?.epcExpiry), "YYYY/MM/DD").isValid()
            ? moment(decodeHTML(editEpcApplications?.epcExpiry), "YYYY/MM/DD").format("YYYY-MM-DD")
            : undefined
          : undefined,
      title: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.title)
        : decodeHTML(editEpcApplications?.title),
      firstName: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.firstName)
        : decodeHTML(editEpcApplications?.firstName),
      emailAddress: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.emailAddress)
        : decodeHTML(editEpcApplications?.emailAddress),
      designation: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.designation)
        : decodeHTML(editEpcApplications?.designation),
      nric: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.nric)
        : decodeHTML(editEpcApplications?.nric),
      passportNumber: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.passportNumber)
        : decodeHTML(editEpcApplications?.passportNumber),
      mobileNumber: editEpcApplicationsById?.payload
        ? `${decodeHTML(editEpcApplicationsById?.payload?.mobileNumberCountryCode)} ${decodeHTML(editEpcApplicationsById?.payload?.mobileNumber)}`
        : `${decodeHTML(editEpcApplications?.mobileNumberCountryCode)} ${decodeHTML(editEpcApplications?.mobileNumber)}`,
      homeNumberCountryCode: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.homeNumberCountryCode)
        : decodeHTML(editEpcApplications?.homeNumberCountryCode),
      homeNumber: editEpcApplicationsById?.payload
        ? `${decodeHTML(editEpcApplicationsById?.payload?.homeNumberCountryCode)} ${decodeHTML(editEpcApplicationsById?.payload?.homeNumber)}`
        : `${decodeHTML(editEpcApplications?.homeNumberCountryCode)} ${decodeHTML(editEpcApplications?.homeNumber)}`,
      mailingAddress: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.mailingAddress)
        : decodeHTML(editEpcApplications?.mailingAddress),
      postalCode: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.postalCode)
        : decodeHTML(editEpcApplications?.postalCode),
      nationality: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.nationality)
        : decodeHTML(editEpcApplications?.nationality),
      gender: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.gender)
        : decodeHTML(editEpcApplications?.gender),
      maritialStatus: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.maritialStatus)
        : decodeHTML(editEpcApplications?.maritialStatus),
      dateOfBirth: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.dateOfBirth)
        : decodeHTML(editEpcApplications?.dateOfBirth),
      profession: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.profession)
        : decodeHTML(editEpcApplications?.profession),
      incomeRange: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.incomeRange)
        : decodeHTML(editEpcApplications?.incomeRange),
      promotionsEmail:
        (editEpcApplicationsById?.payload
          ? decodeHTML(editEpcApplicationsById?.payload?.promotionsEmail)
          : decodeHTML(editEpcApplications?.promotionsEmail)) === "true",
      // promotionsEmail: editEpcApplicationsById?.payload
      //   ? decodeHTML(editEpcApplicationsById?.payload?.promotionsEmail) === "true"|| decodeHTML(editEpcApplicationsById?.payload?.promotionsEmail) === true
      //     ? ["Email"]
      //     : []
      //   : decodeHTML(editEpcApplications?.promotionsEmail) === "true" || decodeHTML(editEpcApplications?.promotionsEmail) === true
      //   ? ["Email"]
      //   : [],
      epcUpgradationRequest: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.epcUpgradationRequest)
        : decodeHTML(editEpcApplications?.epcUpgradationRequest),
      state: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.state)
        : decodeHTML(editEpcApplications?.state),
      country: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.country)
        : decodeHTML(editEpcApplications?.country),
      mobileNumberCountryCode: editEpcApplicationsById?.payload
        ? decodeHTML(editEpcApplicationsById?.payload?.mobileNumberCountryCode)
        : decodeHTML(editEpcApplications?.mobileNumberCountryCode),
      isForRenewal:
        (editEpcApplicationsById?.payload
          ? decodeHTML(editEpcApplicationsById?.payload?.isForRenewal)
          : decodeHTML(editEpcApplications?.isForRenewal)) === "true",
    },
    fields: fields.epcApplications,
  };

  console.log("epcApplicationVlaue", epcApplicationsFormConfig.initialValues);

  const onSubmit = async (data: FieldValues, apiUrl: string, action: string, method: string) => {
    console.log("data-123", data);
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    const dateKeys = ["epcExpiry"];
    for (const key of dateKeys) {
      try {
        if (data[key]) {
          const formattedDate = moment(data[key], "YYYY-MM-DD").format("YYYY/MM/DD");
          data[key] = formattedDate === "Invalid date" ? null : formattedDate;
        }
      } catch (error) {
        console.error(`Error processing ${key}:`, error);
      }
    }
    const mobileKeys = ["mobileNumber", "homeNumber"];
    for (const key of mobileKeys) {
      try {
        if (data[key]) {
          const trimmedValue = data[key].trim();
          if (trimmedValue.toLowerCase() === "null null" || trimmedValue.toLowerCase() === "undefined undefined") {
            data[key] = "";
            data[`${key}CountryCode`] = "";
            continue;
          }
          const match = trimmedValue.match(/^(\+\d+)\s*(.*)$/);
          if (match) {
            data[`${key}CountryCode`] = match[1];
            data[key] = match[2];
          }
        }
      } catch (error) {
        console.error(`Error processing ${key}:`, error);
      }
    }
    console.log(
      "dataaaasssssssssss",
      data.cardType,
      query.get("editId"),
      data.epcExpiry,
      editEpcApplications?.epcExpiry,
      editEpcApplicationsById?.payload?.epcExpiry
    );
    if (
      data.epcType === "PRIORITY" &&
      (query.get("editId") || query.get("type") === "update") &&
      data.epcExpiry !== (editEpcApplications?.epcExpiry || editEpcApplicationsById?.payload?.epcExpiry)
    ) {
      data.isForRenewal = true;
    }
    const checkBoxKeys = ["promotionsEmail", "isForRenewal"];

    for (const key of checkBoxKeys) {
      try {
        if (data[key] === true) {
          data[key] = "true";
        } else {
          data[key] = "false";
        }
      } catch (error) {
        console.error(`Error processing ${key}:`, error);
      }
    }

    const payload = {
      ...(action === "UPDATE" && { id: editEpcApplications?.id || editEpcApplicationsById?.payload?.id }),
      ...data,
      published: true,
    };
    try {
      let response;

      // if (method === "PUT") {
      //   response = await axios.put(apiUrl, payload);
      // } else {
      //   response = await axios.post(apiUrl, payload);
      // }

      // remove baseURL part since eramanBEApi already has it
      const endpoint = apiUrl.replace(eramanApiURL, "");

      if (method === "PUT") {
        response = await eramanBEApi.put(endpoint, payload);
      } else {
        response = await eramanBEApi.post(endpoint, payload);
      }

      console.log("Response:", response);
      openToast({
        content: "Data Saved Successfully",
        type: "success",
      });
      refetchEditEpcApplications();
      navigate("/dedicated/eraman/epc-applications");
    } catch (error: any) {
      console.error("Error:", error);

      if (error.response) {
        const errorMessage = error.response.data || "An unexpected error occurred.";
        message.error(errorMessage);
      } else {
        message.error("Network error or server not reachable.");
      }
    }
  };
  const getPreviewContent = (status: any, epcContent: any, renewalContent: any) => {
    const normalizedStatus = status?.toString().trim().replace(/\s+/g, " ");
    switch (normalizedStatus) {
      case "Pending Approval (New Renewal)":
        return `User has ${renewalContent}. Kindly review`;
      case "Pending Approval (New Upgrade)":
        return `User has ${epcContent}. Kindly review`;
      case "Pending Approval (New EPC)":
        return `User has Created a new EPC. Kindly review`;
      default:
        return null;
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingEpcApplications}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} EPC Application`}
      showBack
    >
      {cardEPCId && epcCard && cardExpiryDate && epcCardBarcode && (
        <EPCCardDisplay
          epcCard={epcCard}
          cardEPCId={cardEPCId}
          cardExpiryDate={cardExpiryDate}
          epcCardBarcode={epcCardBarcode}
        />
      )}
      <DynamicForm
        isLoading={isLoadingEpcApplications || drilldownLoading}
        config={epcApplicationsFormConfig}
        // onSubmit={(data, buttonValue, reviewNotes) =>
        // onSubmit(
        //   data,
        //   `${eramanApiURL}/admin/epc`,
        //   `${query.get("editId") || query.get('type')==='update' ? "UPDATE" : "CREATE"}`,
        //   `${query.get("editId") || query.get('type')==='update' ? "PUT" : "POST"}`,
        //   buttonValue == "save" ? "DRAFT" : "PENDING",
        //   reviewNotes
        // )
        // }
        previewContent={getPreviewContent(
          editEpcApplicationsById?.payload?.epcStatus || editEpcApplications?.epcStatus,
          editEpcApplicationsById?.payload?.epcUpgradationRequest || editEpcApplications?.epcUpgradationRequest,
          editEpcApplications?.epcRenewalRequest || editEpcApplicationsById?.payload?.epcRenewalRequest
        )}
        CreatingNewOne={
          !query.get("id") && !query.get("editId") && query.get("type") === "create"
            ? true
            : (query.get("id") && query.get("type") === "update") || query.get("editId")
              ? false
              : true
        }
        finalData={(data: FieldValues) => {
          console.log("Updated Form Data:", data);
          onSubmit(
            data,
            `/admin/epc`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PUT" : "POST"}`
          );
        }}
        hideButton={true}
      />
    </ContentWrapper>
  );
};
